<template>
  <aside
    v-if="showSideBar"
    class="sidebar-rail"
  >
    <el-menu class="sidebar-menu" :default-active="$route.path" collapse router>
      <el-menu-item index="/">
        <lucide-icon class="back-to-map-arrow" name="arrow-left" />
        <lucide-icon class="back-to-map-icon" name="map" />
        <span slot="title">{{ $t('Back to map') }}</span>
      </el-menu-item>
      <el-menu-item index="/settings/vehicles">
        <lucide-icon name="car" />
        <span slot="title">{{ $t('settings.vehicles') }}</span>
      </el-menu-item>
      <el-menu-item index="/settings/groups">
        <lucide-icon name="grip" />
        <span slot="title">{{ $t('settings.groups') }}</span>
      </el-menu-item>
      <el-menu-item index="/settings/drivers">
        <lucide-icon name="id-card" />
        <span slot="title">{{ $t('settings.drivers') }}</span>
      </el-menu-item>
      <el-menu-item index="/settings/users">
        <lucide-icon name="users" />
        <span slot="title">{{ $t('settings.users') }}</span>
      </el-menu-item>
      <el-menu-item index="/settings/links">
        <lucide-icon name="user-round-clock" />
        <span slot="title">{{ $t('settings.temporary_links') }}</span>
      </el-menu-item>
      <el-menu-item index="/settings/geofence">
        <lucide-icon name="map-pinned" />
        <span slot="title">{{ $t('settings.zone') }}</span>
      </el-menu-item>
      <el-menu-item index="/settings/alerts">
        <lucide-icon name="bell" />
        <span slot="title">{{ $t('settings.alerts') }}</span>
      </el-menu-item>
      <el-menu-item index="/settings/maintenance">
        <lucide-icon name="wrench" />
        <span slot="title">{{ $t('settings.maintenance') }}</span>
      </el-menu-item>
      <el-menu-item index="/settings/reports">
        <lucide-icon name="note" />
        <span slot="title">{{ $t('route.scheduler') }}</span>
      </el-menu-item>
      <el-menu-item index="/settings/map">
        <lucide-icon name="map" />
        <span slot="title">{{ $t('settings.map') }}</span>
      </el-menu-item>
      <el-menu-item index="/settings/profile">
        <lucide-icon name="user-round" />
        <span slot="title">{{ $t('navbar.profile') }}</span>
      </el-menu-item>
    </el-menu>
  </aside>
</template>

<script>
import { schedulerIsActive } from '@/utils/modules'
import store from '@/store'
import LucideIcon from '@/components/LucideIcon'
import '../sidebar.scss'

export default {
  name: 'SettingsSideBar',
  components: { LucideIcon },
  computed: {
    showSideBar() {
      return this.$route.path.includes('settings')
    }
  },
  methods: {
    manageSchedules() {
      return schedulerIsActive(store.getters.user)
    }
  }
}
</script>
